// extracted by mini-css-extract-plugin
export default {"root":"+4etw","item":"bcWSG","reverse":"n4m+v","button":"_4Gbpp","subheading":"F8ygD","bullet":"sCOxV"};